import { ProductLine } from "@typed/product";

export const CompareColorsByHueAndPrimaryLine = (a: Queries.ProductFragment, b: Queries.ProductFragment): number => {
  // GSF: 9/21/23 We aren't sorting by hue-value anymore.  We maintain simple sort at product level
  const sortA = a?.sort ?? 100000;
  const sortB = b?.sort ?? 100000;

  const primaryLineASort =
    [...(a?.product_groups ?? [])].sort((pg1, pg2) => (pg1.sort ?? 100000) - (pg2.sort ?? 100000)).at(0)?.sort ?? 1000000;
  const primaryLineBSort =
    [...(b?.product_groups ?? [])].sort((pg1, pg2) => (pg1.sort ?? 100000) - (pg2.sort ?? 100000)).at(0)?.sort ?? 1000000;

  return sortA !== sortB ? sortA - sortB : primaryLineASort - primaryLineBSort;
};

export const ReduceProductListToFirstOccurrenceOfEachColor = (result: Queries.ProductFragment[], value: Queries.ProductFragment) => {
  if (
    result.length === 0 ||
    result[result.length - 1].products_colors?.color.color_name !== value.products_colors?.color.color_name ||
    (!result[result.length - 1].products_colors?.color.color_name && result[result.length - 1].product_name !== value.product_name)
  )
    result.push(value);

  return result;
};

export const GetColorLineMap = (colors: Queries.ProductFragment[]): Map<string, ProductLine> =>
  colors.reduce((result: Map<string, ProductLine>, value) => {
    value?.product_groups.forEach((pg) => {
      if (pg.id && pg.name && pg.slug) {
        if (!result.has(pg.id)) result.set(pg.id, { name: pg.name, slug: pg.slug });
      }
    });
    return result;
  }, new Map());
